<template>
  <div>
    <section class="section">
      <div class="columns">
        <div class="column">
          <div class="row panel">
            <div class="panel-heading">
              <div class="title is-4 has-text-info uppercase mb-4">
                Options liées à votre trunk optique
              </div>
              <div class="columns">
                <OptionButton
                  :selected="!reflectometrie"
                  class="column"
                  title="Photométrie"
                  :tooltip="tooltipForOptions['photometrie']"
                  @click="setOption({option: 'reflectometrie', value: false})"
                >
                  <Photometrie width="150px" />
                </OptionButton>
                <OptionButton
                  :selected="reflectometrie"
                  class="column"
                  title="Réflectométrie"
                  :tooltip="tooltipForOptions['refelctometrie']"
                  @click="setOption({option: 'reflectometrie', value: true})"
                >
                  <Reflectometrie width="150px" />
                </OptionButton>
                <OptionButton
                  :selected="regainage"
                  class="column"
                  title="Regainage"
                  :tooltip="tooltipForOptions['regainage']"
                  :disabled="isRegainageDisabled"
                  @click="isRegainageDisabled || setOption({option: 'regainage', value: !regainage})"
                >
                  <Regainage width="150px" />
                </OptionButton>
                <OptionButton
                  :selected="chaussette"
                  class="column"
                  title="2e Chaussette de tirage"
                  :tooltip="tooltipForOptions['chaussette']"
                  @click="setOption({option: 'chaussette', value: !chaussette})"
                >
                  <Chaussette width="150px" />
                </OptionButton>
                <OptionButton
                  :selected="livraison"
                  :disabled="shippingOptionDisabled"
                  class="column"
                  title="Livraison Express"
                  :tooltip="tooltipForOptions['livraison']"
                  @click="shippingOptionDisabled || setOption({option: 'livraison', value: !livraison})"
                >
                  <Livraison width="150px" />
                </OptionButton>
              </div>
            </div>

            <div class="panel-heading mt-4">
              <div class="title is-4 has-text-info uppercase mb-4">
                Options tiroir optique
              </div>
              <div class="title is-5 has-text-primary uppercase mb-4">
                Votre trunk optique
              </div>
              <TrunkVisual
                :extremite-a="configuration.extremite_a"
                :extremite-b="configuration.extremite_b"
                :mode="configuration.mode"
                :with-details="false"
                :with-text="false"
                :type-de-gaine="configuration.type_de_gaine"
                :nombre-de-brins="configuration.nombre_de_brins"
                :longueur="configuration.longueur_du_lien"
                class="mb-10"
              />
              <div class="columns">
                <div class="column">
                  <div class="title is-5 has-text-primary uppercase mb-4">
                    Tiroir optique A
                  </div>
                  <div v-if="relevantTiroirForTrunk['extremiteA'].length">
                    <OptionButton
                      v-for="tiroir in relevantTiroirForTrunk['extremiteA']"
                      :key="tiroir.id"
                      :title="formatTiroirName(tiroir.designation)"
                      :selected="tiroir_a_id === tiroir.id"
                      class="column"
                      @click="setTiroir({ extremite: 'a', id: tiroir.id })"
                    >
                      <component
                        :is="require(`@/assets/unitrunk/tiroirs/${tiroir.svg}`)"
                        width="60%"
                        class="mt-3"
                      />
                    </OptionButton>
                  </div>
                  <div v-else>
                    Pas de tiroir optique disponible
                  </div>
                </div>
                <div class="column is-flex flex-col">
                  <div class="title is-5 has-text-primary uppercase mb-3">
                    Tiroir optique B
                  </div>
                  <div v-if="relevantTiroirForTrunk['extremiteB'].length">
                    <OptionButton
                      v-for="tiroir in relevantTiroirForTrunk['extremiteB']"
                      :key="tiroir.id"
                      :title="formatTiroirName(tiroir.designation)"
                      :selected="tiroir_b_id === tiroir.id"
                      class="column"
                      @click="setTiroir({ extremite: 'b', id: tiroir.id })"
                    >
                      <component
                        :is="require(`@/assets/unitrunk/tiroirs/${tiroir.svg}`)"
                        width="60%"
                        class="mt-3"
                      />
                    </OptionButton>
                  </div>
                  <div v-else>
                    Pas de tiroir optique disponible
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter panel">
          <div class="panel-heading">
            <div class=" title is-4 has-text-info uppercase mb-4">
              Options Trunk
            </div>
            <div class="">
              <form @submit.prevent="handleFormSubmit">
                <b-field label="Mesure" />
                <b-field expanded>
                  <b-radio-button
                    v-model="reflectometrie"
                    :native-value="false"
                    type="is-primary"
                    expanded
                  >
                    <span>Photométrie</span>
                  </b-radio-button>

                  <b-radio-button
                    v-model="reflectometrie"
                    expanded
                    :native-value="true"
                    type="is-primary"
                  >
                    <span>Réflectométrie</span>
                  </b-radio-button>
                </b-field>

                <b-field
                  label="Regainage"
                  expanded
                />
                <b-field>
                  <b-radio-button
                    v-model="regainage"
                    expanded
                    :native-value="true"
                    :disabled="isRegainageDisabled"
                    type="is-primary"
                  >
                    <span>Avec</span>
                  </b-radio-button>

                  <b-radio-button
                    v-model="regainage"
                    expanded
                    :native-value="false"
                    type="is-primary"
                  >
                    <span>Sans</span>
                  </b-radio-button>
                </b-field>

                <b-field
                  label="2e Chaussette de tirage"
                  expanded
                />
                <b-field>
                  <b-radio-button
                    v-model="chaussette"
                    expanded
                    :native-value="true"
                    type="is-primary"
                  >
                    <span>Avec</span>
                  </b-radio-button>

                  <b-radio-button
                    v-model="chaussette"
                    expanded
                    :native-value="false"
                    type="is-primary"
                  >
                    <span>Sans</span>
                  </b-radio-button>
                </b-field>

                <b-field
                  label="Livraison rapide"
                  expanded
                />
                <b-field>
                  <b-radio-button
                    v-model="livraison"
                    expanded
                    :native-value="true"
                    :disabled="shippingOptionDisabled"
                    type="is-primary"
                  >
                    <span>Avec</span>
                  </b-radio-button>

                  <b-radio-button
                    v-model="livraison"
                    expanded
                    :native-value="false"
                    :disabled="shippingOptionDisabled"
                    type="is-primary"
                  >
                    <span>Sans</span>
                  </b-radio-button>
                </b-field>

                <hr class="divider">

                <div class=" title is-4 has-text-info uppercase mb-4">
                  Options Tiroirs
                </div>
                <b-field label="Extrémité A" />
                <b-radio-button
                  v-for="tiroir in relevantTiroirForTrunk['extremiteA']"
                  :key="tiroir.id"
                  v-model="tiroir_a_id"
                  name="tiroir_a"
                  class="mb-1"
                  expanded
                  :native-value="tiroir.id"
                  :required="true"
                  type="is-primary"
                >
                  <span>{{ formatTiroirName(tiroir.designation) }}</span>
                </b-radio-button>
                <b-radio-button
                  v-model="tiroir_a_id"
                  name="tiroir_a"
                  expanded
                  :native-value="null"
                  :required="true"
                  type="is-primary"
                >
                  <span>Je n'ai pas besoin de tiroir</span>
                </b-radio-button>

                <b-field
                  label="Extrémité B"
                  class="mt-4"
                />
                <b-radio-button
                  v-for="tiroir in relevantTiroirForTrunk['extremiteB']"
                  :key="tiroir.id"
                  v-model="tiroir_b_id"
                  name="tiroir_b"
                  :required="true"
                  class="mb-1"
                  expanded
                  :native-value="tiroir.id"
                  type="is-primary"
                >
                  <span>{{ formatTiroirName(tiroir.designation) }}</span>
                </b-radio-button>
                <b-radio-button
                  v-model="tiroir_b_id"
                  name="tiroir_b"
                  :required="true"
                  expanded
                  :native-value="null"
                  type="is-primary"
                >
                  <span>Je n'ai pas besoin de tiroir</span>
                </b-radio-button>
                <b-field
                  grouped
                  class="mt-8"
                  position="is-right"
                >
                  <b-field grouped>
                    <b-button
                      type="is-info"
                      tag="router-link"
                      to="/uni-trunk/configuration"
                    >
                      Retour
                    </b-button>
                  </b-field>
                  <b-field grouped>
                    <b-button
                      type="is-success"
                      native-type="submit"
                    >
                      Suivant
                    </b-button>
                  </b-field>
                </b-field>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import {
  mapState, mapMutations, mapActions, mapGetters,
} from 'vuex';
import OptionButton from '@/components/OptionButton.vue';
import TrunkVisual from '@/views/partials/TrunkVisual.vue';

import Chaussette from '@/assets/unitrunk/options/2-eme-chaussette-de-tirage.svg';
import Livraison from '@/assets/unitrunk/options/livraison-express.svg';
import Photometrie from '@/assets/unitrunk/options/photometrie.svg';
import Reflectometrie from '@/assets/unitrunk/options/reflectometrie.svg';
import Regainage from '@/assets/unitrunk/options/regainage.svg';

import TrunkMixin from '@/views/mixins/trunkMixin';

import { TOOLTIP_FOR_OPTIONS, TYPES_DE_GAINE } from '@/constants.js';

export default {
  name: 'Trunk',
  components: {
    OptionButton,
    Chaussette,
    Livraison,
    Photometrie,
    Reflectometrie,
    Regainage,
    TrunkVisual,
  },
  mixins: [TrunkMixin],
  data() {
    return {
      tooltipForOptions: TOOLTIP_FOR_OPTIONS,
      typesDeGaine: TYPES_DE_GAINE,
    };
  },
  computed: {
    ...mapState('trunk', ['configuration', 'shippingOptionDisabled']),
    ...mapGetters('trunk', ['relevantTiroirForTrunk', 'isConfigurationFull']),
    ...mapFields('trunk', [
      'options.reflectometrie',
      'options.regainage',
      'options.chaussette',
      'options.livraison',
      'configuration.tiroir_a_id',
      'configuration.tiroir_b_id',
    ]),
    isRegainageDisabled() {
      return (
        this.configuration.type_de_gaine === this.typesDeGaine[0]
        || this.configuration.type_de_gaine === this.typesDeGaine[1]
      );
    },
  },
  created() {
    this.fetchTiroirsOptiques();
    if (!this.isConfigurationFull) {
      this.$router.push('/uni-trunk/configuration');
    }
    this.setLivraisonOption();
  },
  methods: {
    ...mapMutations('trunk', ['setOption', 'setTiroir']),
    ...mapActions('trunk', [
      'simulateTrunkConfiguration',
      'fetchTiroirsOptiques',
      'getShippingAvailability',
    ]),
    handleFormSubmit() {
      this.simulateTrunkConfiguration()
        .then(() => {
          this.$router.push('/uni-trunk/resume');
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push(`/connexion?redirect=${this.$router.currentRoute.path}`);
          }
        });
    },
    setLivraisonOption() {
      this.getShippingAvailability();
    },
  },
};
</script>

<style lang="scss">
.left-panel {
  max-width: 200px;
}
.divider {
  width: 100%;
  border-top: 3px solid #bbb;
}

.wrap {
  display: flex;
}
.wrap svg {
  object-fit: contain;
}
</style>
